import React, { Component } from 'react';
import NavBar from '../Components/NavBar/NavBar.js';
import './Catalogo.css';
import Footer from '../Components/Footer/Footer.js';
import FooterContatos from '../Components/Footer/FooterContatos.js';
import ButtonC from '../Components/ButtonCatalogo/ButtonC';
import servicosp1 from '../Images/servicoss/servicosp1.jpg';
import servicosp2 from '../Images/servicoss/servicosp2.jpg';
import servicosp3 from '../Images/servicoss/servicosp3.jpg';
import servicosp4 from '../Images/servicoss/servicosp4.jpg';
import servicosp5 from '../Images/servicoss/servicosp5.jpg';
import servicosp6 from '../Images/servicoss/servicosp6.jpg';
import FloatingWhatsApp from 'react-floating-whatsapp';
import LOGOL from '../Images/logo2.png';

class ATIVIDADES extends Component {
 render() {
 return (
   <div className="backGBlack">
   <NavBar/>
    <div className="EspacoBotoes"></div>
  <div className="ButtonsItens">
  <ButtonC/>
     </div>
     <div className="EspacoBotoes"></div>
   <div className="CatalogoPageCss">
     <img src={servicosp1} width="auto" alt="servicosp1"></img>
     <img src={servicosp2} width="auto" alt="servicosp2"></img>
     <img src={servicosp3} width="auto" alt="servicosp3"></img>
     <img src={servicosp4} width="auto" alt="servicosp4"></img>
     <img src={servicosp5} width="auto" alt="servicosp5"></img>
     <img src={servicosp6} width="auto" alt="servicosp6"></img>
   </div>
   <div className="EspacoBotoes"></div>
   <Footer/>
   <FooterContatos/>
   <FloatingWhatsApp avatar={LOGOL} position="absolute" accountName="Centro Oeste" allowClickAway="true" placeholder="Escreva sua mensagem"  chatMessage="Olá, como posso te ajudar?" statusMessage="online" allowEsc="true" phoneNumber="5567998383492"/>
</div>
 );
 }
}
export default ATIVIDADES;